import { render } from "./CreateTaskNote.vue?vue&type=template&id=20a98fab"
import script from "./CreateTaskNote.vue?vue&type=script&lang=js"
export * from "./CreateTaskNote.vue?vue&type=script&lang=js"

import "./CreateTaskNote.vue?vue&type=style&index=0&id=20a98fab&lang=css"

import exportComponent from "E:\\Sources\\Repos\\TaskApi\\TaskApp.VueCore\\clientTaskApp\\clientTaskApp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__